import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";

export default function LoggedOutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/campwithfriends-logo.png"
          alt="Camp With Friends Logo"
          style={{ width: "200px", marginBottom: "1rem" }}
        />
        <h2 style={{ color: "white" }}>You have been logged out</h2>
        <p style={{ color: "#ccc" }}>Redirecting to login…</p>
      </div>
    </div>
  );
}
